// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainPage_mainContainer__RVNQ8"};